import { useEffect } from "react";
import { BrowserView, isBrowser, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import SavingMobile from "./savingMobile";
import SavingWeb from "./savingWeb";
const SavingComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("Saving");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toCreatePage = (studentId: string) => {
    navigate(`/saving/create/${studentId}`);
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Saving",
    });
    if (isBrowser) {
    }
  }, []);
  return (
    <>
      <BrowserView>
        <SavingWeb
          toCreatePage={toCreatePage}
        ></SavingWeb>
      </BrowserView>
      <MobileView>
        <SavingMobile
          toCreatePage={toCreatePage}
        ></SavingMobile>
      </MobileView>
    </>
  );
};

export default SavingComponent;
